import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "booklettypeoptions"
    }}>{`BookletTypeOptions`}</h1>
    <p>{`Booklet type options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWO_UP_SADDLE_STITCH`}</strong>{` = 1110594387`}</p>
      <p parentName="blockquote">{`Two up saddle stitch imposition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWO_UP_PERFECT_BOUND`}</strong>{` = 1110593602`}</p>
      <p parentName="blockquote">{`Two up perfect bound imposition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWO_UP_CONSECUTIVE`}</strong>{` = 1110590291`}</p>
      <p parentName="blockquote">{`Two up consecutive imposition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`THREE_UP_CONSECUTIVE`}</strong>{` = 1110655827`}</p>
      <p parentName="blockquote">{`Three up consecutive imposition.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FOUR_UP_CONSECUTIVE`}</strong>{` = 1110721363`}</p>
      <p parentName="blockquote">{`Four up consecutive imposition.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      